export const btnConfig = [
  { label: 'no', value: false },
  { label: 'yes', value: true },
]